import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.topaffiliation.net";

export const Seo = ({
  title,
  description,
  path = "",
  image,
  type = "website",
  jsonLd,
}) => {
  const url = `${SITE_URL}${path}`;
  const img = image || `${SITE_URL}/logo.png`;
  return (
    <Helmet>
      <html lang="it" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="TopAffiliation" />
      <meta property="og:locale" content="it_IT" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
